const allLocalesEnvParsed = process.env.NEXT_PUBLIC_ALL_LOCALES?.split(
  ','
) as LocaleString[]

export const allLocales: LocaleString[] = !!allLocalesEnvParsed?.length
  ? allLocalesEnvParsed
  : ['de', 'en']
export const defaultLocale = allLocales[0]
export type LocaleString = 'de' | 'en'
